import { alpha, Button, Stack } from '@mui/material';
import React from 'react';

export default function Buble({ text, isLeft = false, onClick, isSelected = false }) {
  return (
    <Stack width={1} alignItems={!isLeft ? 'flex-end' : 'flex-start'}>
      <Stack
        {...(onClick && { component: Button })}
        maxWidth={0.9}
        p={2}
        onClick={onClick}
        borderRadius={2}
        border={isLeft ? 'none' : (t) => `1px solid ${t.palette.primary.main}`}
        {...(isSelected
          ? { bgcolor: (t) => t.palette.primary.main }
          : { bgcolor: isLeft ? (t) => alpha(t.palette.primary.main, 0.1) : '' })}
        sx={{
          ...(isSelected ? { color: 'common.white' } : { color: isLeft ? 'inherit' : (t) => t.palette.primary.main }),
          ...(onClick && {
            ':hover': {
              bgcolor: 'primary.main',
              color: 'common.white',
            },
          }),
        }}
      >
        {text}
      </Stack>
    </Stack>
  );
}
